import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export const notOnlyDigits = (c: UntypedFormGroup): ValidationErrors | null => {
    const REGEXP = /.*[^0-9].*/;

    return REGEXP.test(c.value)
        ? null
        : {
              notOnlyDigits: {
                  valid: false
              }
          };
};

export const passwordRequirements = (c: UntypedFormGroup): ValidationErrors | null => {
    const v = c.value;
    let count = 0;
    if (v.match(/\d+/)) {
        count = count + 1;
    }
    if (v.match(/[A-Z]+/)) {
        count = count + 1;
    }
    if (v.match(/[a-z]+/)) {
        count = count + 1;
    }
    if (v.match(/[!@#$%^&*=~_<>?:"{}]+/)) {
        count = count + 1;
    }

    return count >= 3
        ? null
        : {
              passwordRequirements: {
                  valid: false
              }
          };
};

export const passwordsNotEqualToCurrent = (c: UntypedFormGroup): ValidationErrors | null => {
    const v = c.value;
    const e = c.root.value.currentPassword;
    return !(v === e)
        ? null
        : {
              passwordsNotEqualToCurrent: {
                  valid: false
              }
          };
};

export const usernameNotEqualToCurrent = (c: UntypedFormGroup): ValidationErrors | null => {
    const v = c.value;
    const e = c.root.value.currentUsername;
    return !(v === e)
        ? null
        : {
              usernameNotEqualToCurrent: {
                  valid: false
              }
          };
};
